import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { widgetTypes} from 'src/app/dashboards/models';
import {NgSelectComponent} from '@ng-select/ng-select';
import { I18NextPipe } from 'angular-i18next';

@Component({
    selector: 'app-widget-type-select',
    templateUrl: './widget-type-select.component.html',
    styleUrls: ['./widget-type-select.component.scss'],
    standalone: false
})
export class WidgetTypeSelectComponent implements OnInit  {
  @Input() public widgetType: number;  
  @Input() title: string;
  @Input() hideLabelType: boolean = false;
  @Input() showTooltip: boolean = false;

  @Input() set disabledItems(value: number[]) {
    setTimeout(() => {
      let types = this.widgetTypes.map((t) => ({ ...t, disabled: (value?.indexOf(t.value) > -1) }))
      this.widgetTypes = types;
    }, 0)
  }

  @Output() modelChange = new EventEmitter<number>();

  isOpen: boolean;
  public widgetTypes = widgetTypes;
  @ViewChild('select') private select: NgSelectComponent;

  constructor( private i18nextPipe: I18NextPipe) {}  

  ngOnInit(): void {
    if (this.hideLabelType) {
      this.widgetTypes = this.widgetTypes.filter(t => t.value != 3);
    }
  }

  tooltip(item){
    if (this.showTooltip && item.disabled && item.value < 3) {
      return this.i18nextPipe.transform('dashboard:To select a chart Visual type, you can have max 4 columns selected in the report. Please reduce the number of columns if you want to create a chart.');
    }
    return null;
  }
}
